import { useEffect } from 'react';
import { GradientDots } from '@/components/ui/GradientDots';
import { OperatorWordmark } from '@/components/auth/OperatorWordmark';
import { clearBrowserAuthState } from '@/utils/clear-browser-state';

/**
 * Recovery page for users hitting CloudFront 431 due to oversized cookies.
 * Wipes the JS-visible cookie jar + local/session storage on mount, then
 * full-page-redirects to /signin?reset=1. The full reload guarantees the
 * next request goes out with a fresh cookie header (no stale React state).
 */
export default function SignInReset() {
  useEffect(() => {
    clearBrowserAuthState();
    window.location.replace('/signin?reset=1');
  }, []);

  return (
    <div
      className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-12"
      style={{ backgroundColor: 'hsl(var(--auth-bg))' }}
    >
      <GradientDots />
      <div className="relative z-10 w-full max-w-3xl rounded-[32px] border border-foreground/15 bg-card/95 dark:bg-card/15 p-6 shadow-[0_80px_160px_-30px_rgba(0,0,0,0.8),0_40px_80px_-20px_rgba(0,0,0,0.6)] backdrop-blur-3xl sm:p-12 md:p-16 lg:p-20 2xl:p-28 2xl:max-w-4xl">
        <div className="flex flex-col items-center text-center">
          <OperatorWordmark size="xl" />
          <p className="mt-6 text-[10px] tracking-[0.15em] sm:text-xs sm:tracking-[0.25em] uppercase text-muted-foreground">
            Resetting browser session…
          </p>
        </div>
      </div>
    </div>
  );
}
